// © 2025 Camp Promethean, LLC. All Rights Reserved.

import { IntegrationsManager } from "@/components/profile/integrations/IntegrationsManager";
import { DashboardContent } from "@/components/layouts/DashboardContent";
import { useAuth } from "@/contexts/AuthContext";

export default function IntegrationsPage() {
  const { profile } = useAuth();

  if (!profile) {
    return null;
  }

  return (
    <DashboardContent className="space-y-6">
      <p className="max-w-2xl text-muted-foreground">
        Manage your third-party service integrations.
      </p>
      <IntegrationsManager />
    </DashboardContent>
  );
}
